export type AssignmentData = {
  actor_uuid: string;
  email: string;
  tasks: { key: string }[];
  lastActive?: string;
  lastTask?: string;
};

export enum AssignmentDomain {
  "workflow" = "workflow",
  "blueprint" = "blueprint",
}

export enum AssignmentModel {
  "WorkflowStepConfigs" = "WorkflowStepConfigs",
  "Blueprints" = "Blueprints",
}

export type HeaderAssignmentHeader = {
  name: string;
  key: string;
  doubleFilter?: { name: string }[];
};
